module.exports = __webpack_public_path__ + "static/gitlab-ab50a9fdf868c28f949cf591747d4b2a.svg";